import Dropzone from 'react-dropzone'

import { Box, Button, Icon, Text, theme } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { isVideo } from 'modules/posts/lib/isVideo'

import { PostFormValues } from '../types'
import { dropzone, dropzoneActions, dropzoneDimensions, dropzoneVideo } from './index.vanilla.css'

const ImageUploader = () => {
  const form = useFormContext<PostFormValues>()

  const onDrop = (files: File[]) => {
    const image = files[0]
    form.setFieldValue('coverImageUrl', image)
  }

  const deleteImage = () => form.setValues({ ...form.values, coverImageUrl: null })
  const hasVideo =
    form.values.coverImageUrl instanceof File
      ? form.values.coverImageUrl.type.includes('video')
      : isVideo(form.values.coverImageUrl)

  return (
    <Box
      className={dropzone}
      aria-label={i18n.t('posts.communities.aria_label_image_uploader')}
      style={{
        border: form.values.coverImageUrl
          ? 'none'
          : `${theme.dimensions.s2} dashed ${theme.colors.grey400}`,
        backgroundImage:
          !hasVideo && form.values.coverImageUrl
            ? `url(${
                form.values.coverImageUrl instanceof File
                  ? URL.createObjectURL(form.values.coverImageUrl)
                  : form.values.coverImageUrl
              })`
            : ``,
      }}
    >
      {form.values.coverImageUrl && (
        <Box className={dropzoneActions}>
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Button.Decorative type="primary" iconName="ellipsis" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="center">
              <PopoverMenu.TouchableOption
                title={
                  hasVideo
                    ? i18n.t('posts.communities.delete_video')
                    : i18n.t('posts.event.delete_photo')
                }
                onClick={deleteImage}
                danger
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      )}
      <Dropzone onDrop={onDrop} accept={{ 'image/*': [], 'video/*': [] }} multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <>
            <div
              className={dropzoneDimensions}
              {...getRootProps()}
              style={{ display: hasVideo ? 'none' : 'block' }}
            >
              <input {...getInputProps()} />
              {!form.values.coverImageUrl && (
                <Box
                  alignItems="center"
                  justifyContent="center"
                  height="full"
                  width="full"
                  gap="s8"
                >
                  <Icon.Large icon="file-upload" color="grey700" />
                  <Text.Normal weight="medium" size="300">
                    {i18n.t('posts.communities.add_media')}
                  </Text.Normal>
                  <Text.Normal weight="normal" size="200">
                    {i18n.t('posts.communities.add_media_subtitle')}
                  </Text.Normal>
                  <Text.Normal weight="normal" size="200">
                    {i18n.t('posts.communities.add_media_subtitle_size')}
                  </Text.Normal>
                </Box>
              )}
            </div>
            {hasVideo && form.values.coverImageUrl && (
              <video controls className={dropzoneVideo}>
                <source
                  src={
                    form.values.coverImageUrl instanceof File
                      ? URL.createObjectURL(form.values.coverImageUrl)
                      : form.values.coverImageUrl
                  }
                />
              </video>
            )}
          </>
        )}
      </Dropzone>
    </Box>
  )
}

export default observer(ImageUploader)
